@if (editMode) {
  <div></div>
}
@if (!editMode) {
  <div>
    @if (showRichText) {
      <div>
        <quill-view
          [content]="messageText"
        format="html"></quill-view>
      </div>
    }
    @if (!showRichText) {
      <div
        class="message-text"
      [innerHTML]="messageText | safeHtml"></div>
    }
  </div>
}
